/**
 *
 * @file 项目管理api
 **/

import AXIOS from '@/utils/$axios';
import { createBrowserHistory } from 'history';

AXIOS.interceptors.response.use(
    response => Promise.resolve(response),
    error => {
        if (error.code === 10003) {
            const his = createBrowserHistory();
            his.push('/user-center/project-space');
            his.go();
        }
        return Promise.reject(error);
    }
);

// 项目列表
export const queryProductList = payload =>
    AXIOS.post(`/space/project/project/project-space`, payload);

// 项目详情
export const queryProductContent = (payload, ignoreCode, from) =>
    AXIOS.post(`/space/project/common/content`, payload, {
        cancelWarn({ code }) {
            return ignoreCode === code;
        },
        from,
    });

// 保存项目（创建和编辑）
export const effectProduct = payload => {
    return AXIOS.post('/space/project/project/save', payload);
};

// （续费，待支付，重新下单）
export const payProduct = payload => {
    return AXIOS.post('/space/project/common/project-pay', payload);
};

// （续费，待支付，重新下单）
export const upload = payload => {
    return AXIOS.post('/space/project/common/edit-cover', payload);
};

// （施工计划列表）
export const queryPlanList = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/plan/list', payload);
};

// （施工计划列表）
export const addPlan = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/plan/add', payload);
};

// 计划详情
export const queryDetail = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/plan-detail',
        payload
    );
};

// 计划编辑
export const editPlan = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/plan-edit',
        payload
    );
};

// 动态列表
export const queryDynamics = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/dynamic-list',
        payload
    );
};

// 发布动态
export const publishDynamics = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/save-dynamic',
        payload
    );
};

// 删除动态
export const removeDynamics = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/delete-dynamic',
        payload
    );
};

// 项目成员列表
export const queryMembers = payload => {
    return AXIOS.post('/space/project/common/member-list', payload);
};

// 添加成员获取分享链接
export const inviteMember = payload => {
    return AXIOS.post('/space/project/common/share', payload);
};

// 项目成员的添加，删除，编辑，获取详情
export const modifyInfo = payload => {
    return AXIOS.post('/space/project/common/member-save', payload);
};

// 施工协同附件上传
export const uploadFile = (data, onUploadProgress) =>
    AXIOS.post('/space/project/common/adjunct-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data;charset=UTF-8',
        },
        onUploadProgress,
    });

// 附件操作: 删除下载分享
export const operateAdjunct = payload => {
    return AXIOS.post('/space/project/common/adjunct-data', payload);
};

// 施工计划发布
export const publishPlan = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/check/announce',
        payload
    );
};

// 施工图树
export const queryDrawingTree = payload => {
    return AXIOS.post('/space/project/project-drawing/hierarchy', payload);
};

// 获取施工计划周期
export const queryTimes = payload => {
    return AXIOS.post('/space/project/common/get-plan-times', payload);
};

// 项目施工计划模板列表
export const queryTemplates = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/template/template-list',
        payload
    );
};

// 项目保存施工计划模板
export const saveTemplate = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/template/save-template',
        payload
    );
};

// 计划审核详情
export const queryPlanAudit = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/check/plan-detail',
        payload
    );
};

// 项目审核详情
export const queryProjectAudit = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/check/project-detail',
        payload
    );
};

// 清空计划
export const clearPlans = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/plan/delete', payload);
};

// 删除项目
export const removeProject = payload => {
    return AXIOS.post('/space/project/common/delete', payload);
};

// 重命名项目
export const renameProject = payload => {
    return AXIOS.post('/space/project/common/rechristen', payload);
};

//  退出项目
export const exitProject = payload => {
    return AXIOS.post('/space/project/common/exit-project', payload);
};

//  删除模板
export const deleteTemplate = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/template/delete-template',
        payload
    );
};

//  导出施工计划
export const exportPlans = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/plan/export', payload, {
        responseType: 'blob',
    });
};
// 计划的完成详情
export const queryFinishDetail = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/check/plan-finish',
        payload
    );
};
// 计划排序
export const planSort = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/move-site',
        payload
    );
};
// 查询所有附件
export const queryAccessory = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/plan/dynamic-adjunct-list',
        payload
    );
};

// 获取用户在当前项目中的权限
export const getProjectPermission = payload => {
    return AXIOS.post('/space/project/common/project-power', payload);
};

// 获取模板标签列表
export const getTemplateTagList = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/template/tag-list',
        payload
    );
};

// 催款记录列表
export const getRecords = payload => {
    return AXIOS.post('/space/project/prompt-fund/list', payload);
};

// 发送催款信息
export const sendMessage = payload => {
    return AXIOS.post('/space/project/prompt-fund/send-message', payload);
};

// 添加催款信息
export const addRecords = payload => {
    return AXIOS.post('/space/project/prompt-fund/add', payload);
};

// 修改催款信息
export const putRecord = payload => {
    return AXIOS.post('/space/project/prompt-fund/update', payload);
};

// 删除催款信息
export const deleteRecord = payload => {
    return AXIOS.post('/space/project/prompt-fund/delete', payload);
};

// 付款项添加
export const addAccount = payload => {
    return AXIOS.post('/space/project/fund/add', payload);
};

// 修改付款项
export const putAccount = payload => {
    return AXIOS.post('/space/project/fund/update', payload);
};

// 付款项列表
export const getAccounts = payload => {
    return AXIOS.post('/space/project/fund/list', payload);
};

// 付款项删除
export const delAccount = payload => {
    return AXIOS.post('/space/project/fund/delete', payload);
};

//获取增项列表
export const getIncreaseList = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/entry/list', payload);
};
// 原因
export const getReasons = payload => {
    return AXIOS.post('/space/common/get-reason', payload);
};

// 添加增项
export const addAdditional = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/entry/add', payload);
};

// 修改增项
export const putAdditional = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/entry/update', payload);
};

// 删除增项
export const deleteAdditional = payload => {
    return AXIOS.post('/space/project/drawingTeam/plan/entry/delete', payload);
};
// 查询设置指引状态
export const getUserGuidance = params => {
    return AXIOS.get('/space/user/guidance', { params });
};
// 查询用户是否需要指引
export const getProjectStatistics = payload => {
    return AXIOS.post('/space/project/project/project-statistics', payload);
};

export const getMockCreateProject = payload => {
    return AXIOS.post('/space/mock/create-project', payload);
};

// 获取项目计划列表的验收
export const getPlansCheck = payload => {
    return AXIOS.post(
        '/space/project/drawingTeam/plan/check/plan-check-list',
        payload
    );
};
